module.exports = __webpack_public_path__ + "static/media/burrito-chicken-close-up-461198.341e8d2d.png";